import makeArrayMethod from './shared/makeArrayMethod';
export default makeArrayMethod( 'push' );
